import React from "react"

export default function Refresh() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <g clipPath="url(#clip0_171_7386)">
            <path d="M8.09948 8.30883H2.8183C2.6436 8.30883 2.50195 8.16716 2.50195 7.99242V2.71021C2.50195 2.53547 2.6436 2.3938 2.8183 2.3938H4.08367C4.25837 2.3938 4.40002 2.53547 4.40002 2.71021V4.7698C5.60669 3.42948 7.35942 2.59076 9.30796 2.60492C12.9171 2.63113 15.8048 5.54811 15.7972 9.15801C15.7895 12.7629 12.8654 15.6829 9.2594 15.6829C7.56989 15.6829 6.03016 15.0418 4.86987 13.9897C4.73545 13.8678 4.72925 13.6587 4.85756 13.5304L5.75299 12.6348C5.87094 12.5168 6.06043 12.5104 6.18536 12.6209C7.00353 13.345 8.07963 13.7844 9.2594 13.7844C11.8236 13.7844 13.8991 11.7089 13.8991 9.1438C13.8991 6.57914 11.824 4.50317 9.2594 4.50317C7.71733 4.50317 6.3522 5.25401 5.50878 6.41039H8.09948C8.27418 6.41039 8.41582 6.55206 8.41582 6.7268V7.99242C8.41582 8.16716 8.27418 8.30883 8.09948 8.30883Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_171_7386">
               <rect width="13.4973" height="13.5" fill="white" transform="translate(2.50195 2.3938)" />
            </clipPath>
         </defs>
      </svg>
   )
}
